import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import axiosPrivate from 'config/axiosPrivate';
import { ROLES } from 'utils/Constants';
import ErrorSuccesModal from 'components/shared/modal/ErrorSuccesModal';
import DeleteConfirmationModal from 'components/shared/modal/DeleteConfirmationModal';
import { useTranslation } from 'react-i18next';
import { removeGlobalUser } from 'store/AdminClient/CLientAdminManagement';

const DELETE_USER_URL = '/user/';

export const DeleteUserGlobal = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [roleLabel, setRoleLabel] = useState('');

  useEffect(() => {
    switch (props.selected?.role) {
      case ROLES.CLIENT: setRoleLabel('Client'); break;
      case ROLES.CONSULTANT: setRoleLabel('Consultant'); break;
      case ROLES.ADMIN: setRoleLabel('Admin'); break;
      case ROLES.WRITER: setRoleLabel('Rédacteur'); break;
      case ROLES.ADMIN_CLIENT: setRoleLabel('Administrateur'); break;
      case ROLES.GLOBAL_WRITER: setRoleLabel('Rédacteur'); break;
      case ROLES.PROJECT_MANAGER: setRoleLabel('Chef de projet'); break;
      default: setRoleLabel('Utilisateur'); break;
    }
    setConfirmation(true);
  }, [props.selected]);

  // Nom affiché : prénom + nom en priorité, sinon name, sinon mail
  const displayName =
    props.selected?.firstName && props.selected?.lastName
      ? `${props.selected.firstName} ${props.selected.lastName}`
      : props.selected?.name || props.selected?.mail || '';

  const deleteUser = () =>
    axiosPrivate
      .delete(DELETE_USER_URL + props.selected.mail, {
        params: { role: props.selected.role },
      })
      .then(() => {
        setConfirmation(false);
        dispatch(removeGlobalUser(props.selected.mail));
        if (!props.flag) {
          dispatch(removeGlobalUser(props.selected.mail));
        } else {
          props.onDelete(props.selected.mail);
        }
        setIsSuccess(true);
        setErrorSuccessMsg(
          `${roleLabel} ${props.selected.mail} ${t('a été supprimé avec succès')} !`
        );
        setErrorSuccess(true);
      })
      .catch((e) => {
        setConfirmation(false);
        setIsSuccess(false);
        switch (props.selected.role) {
          case ROLES.CLIENT:
            setErrorSuccessMsg(
              e.response.status === 409
                ? `${t('Le client')} ${props.selected.mail} ${t("est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer")}.`
                : t("Oups....! Une erreur s'est produite")
            );
            break;
          case ROLES.CONSULTANT:
            setErrorSuccessMsg(
              e.response.status === 409
                ? `${t('Le consultant')} ${props.selected.mail} ${t('ne peut pas être supprimé car il est lié à des sites web')}.`
                : t("Oups....! Une erreur s'est produite")
            );
            break;
          case ROLES.WRITER:
            setErrorSuccessMsg(
              e.response.status === 409
                ? `${t('Vous ne pouvez pas supprimer le rédacteur')} ${props.selected.mail} ,${t('car celui-ci a déjà rédigé des textes')}.`
                : t("Oups....! Une erreur s'est produite")
            );
            break;
          default:
            setErrorSuccessMsg(
              `${roleLabel} ${props.selected.mail} ${t('ne peut pas être supprimé pour le moment')}`
            );
            break;
        }
        setErrorSuccess(true);
      });

  return (
    <div>
      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() => setErrorSuccess(false)}
        success={isSuccess}
        toggle={() => setErrorSuccess(!errorSuccess)}
      />
      <DeleteConfirmationModal
        open={confirmation}
        userName={displayName}
        userRole={roleLabel}
        handleClose={() => props.Close()}
        executeAction={() => deleteUser()}
      />
    </div>
  );
};